import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { ServiceAutomationDetail } from './service-automation-detail.model';
import * as ServiceAutomationDetailActions from './service-automation-detail.actions';

export const serviceAutomationDetailsFeatureKey = 'serviceAutomationDetails';

export interface State extends EntityState<ServiceAutomationDetail> {
  // additional entities state properties
}

export const adapter: EntityAdapter<ServiceAutomationDetail> = createEntityAdapter<ServiceAutomationDetail>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(ServiceAutomationDetailActions.addServiceAutomationDetail,
    (state, action) => adapter.addOne(action.serviceAutomationDetail, state)
  ),
  on(ServiceAutomationDetailActions.upsertServiceAutomationDetail,
    (state, action) => adapter.upsertOne(action.serviceAutomationDetail, state)
  ),
  on(ServiceAutomationDetailActions.addServiceAutomationDetails,
    (state, action) => adapter.addMany(action.serviceAutomationDetails, state)
  ),
  on(ServiceAutomationDetailActions.upsertServiceAutomationDetails,
    (state, action) => adapter.upsertMany(action.serviceAutomationDetails, state)
  ),
  on(ServiceAutomationDetailActions.updateServiceAutomationDetail,
    (state, action) => adapter.updateOne(action.serviceAutomationDetail, state)
  ),
  on(ServiceAutomationDetailActions.updateServiceAutomationDetails,
    (state, action) => adapter.updateMany(action.serviceAutomationDetails, state)
  ),
  on(ServiceAutomationDetailActions.deleteServiceAutomationDetail,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(ServiceAutomationDetailActions.deleteServiceAutomationDetails,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(ServiceAutomationDetailActions.loadServiceAutomationDetails,
    (state, action) => adapter.setAll(action.serviceAutomationDetails, state)
  ),
  on(ServiceAutomationDetailActions.clearServiceAutomationDetails,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
